import { useLayoutEffect, type RefObject } from 'react';

/** The console header's rendered height, on the document root. The header is
 *  content-sized and differs per persona, so anything that must line up with
 *  it (the docked Ask Moo panel's title bar) reads this instead of guessing. */
export const CONSOLE_HEADER_HEIGHT_VAR = '--console-header-h';

/** Publish `ref`'s height as `CONSOLE_HEADER_HEIGHT_VAR` and keep it current
 *  as the header resizes. Removed again on unmount. */
export function usePublishHeaderHeight(
  ref: RefObject<HTMLElement | null>
): void {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const root = document.documentElement;
    const publish = () => {
      root.style.setProperty(
        CONSOLE_HEADER_HEIGHT_VAR,
        `${el.getBoundingClientRect().height}px`
      );
    };
    publish();
    const observer =
      typeof ResizeObserver === 'undefined'
        ? null
        : new ResizeObserver(publish);
    observer?.observe(el);
    return () => {
      observer?.disconnect();
      root.style.removeProperty(CONSOLE_HEADER_HEIGHT_VAR);
    };
  }, [ref]);
}
